import React from "react";
import AttendanceRecordsShared from "../attendance/AttendanceRecordsShared";

export default function ManagerAttendanceRecords() {
  return <AttendanceRecordsShared backPath="/manager/attendance" />;
}
